﻿import $ from "jquery";
/* Set the defaults for DataTables */
$.extend(true, $.fn.dataTable.defaults, {
  "dom": "<'row'<'col-md-6 col-sm-6'l><'col-md-6 col-sm-6'f>r><'table-scrollable't><'row'<'col-md-6'i><'col-md-6'p>>", // default layout with horizobtal scrollable datatable
  // "dom": "<'row'<'col-md-6 col-sm-12'l><'col-md-6 col-sm-12'f>r>t<'row'<'col-md-5 col-sm-12'i><'col-md-7 col-sm-12'p>>", // datatable layout without  horizobtal scroll(used when bootstrap dropdowns used in the datatable cells)
  "pagingType": "bootstrap_full_number"
});

/* Default Class Modification */
$.extend($.fn.dataTableExt.oStdClasses, {
  //"sWrapper": "dataTables_wrapper",
  "sFilterInput": "form-control",
  "sLengthSelect": "form-control"
});

/* API method to get paging information */
$.fn.dataTableExt.oApi.fnPagingInfo = function(oSettings) {
  return {
    "iStart": oSettings._iDisplayStart,
    "iEnd": oSettings.fnDisplayEnd(),
    "iLength": oSettings._iDisplayLength,
    "iTotal": oSettings.fnRecordsTotal(),
    "iFilteredTotal": oSettings.fnRecordsDisplay(),
    "iPage": oSettings._iDisplayLength === -1 ?
      0 : Math.ceil(oSettings._iDisplayStart / oSettings._iDisplayLength),
    "iTotalPages": oSettings._iDisplayLength === -1 ?
      0 : Math.ceil(oSettings.fnRecordsDisplay() / oSettings._iDisplayLength)
  };
};

/* Bootstrap style full number pagination control */
$.extend($.fn.dataTableExt.oPagination, {
  "bootstrap_full_number": {
    "fnInit": function(oSettings, nPaging, fnDraw) {
      var oLang = oSettings.oLanguage.oPaginate;
      var fnClickHandler = function(e) {
        e.preventDefault();
        if (oSettings.oApi._fnPageChange(oSettings, e.data.action)) {
          fnDraw(oSettings);
        }
      };

      $(nPaging).append(
        '<ul class="pagination">' +
        '<li class="page-item prev disabled"><a href="#" class="page-link" title="">' + oLang.sFirst + '</a></li>' +
        '<li class="page-item prev disabled"><a href="#" class="page-link" title="">' + oLang.sPrevious + '</a></li>' +
        '<li class="page-item next disabled"><a href="#" class="page-link" title="">' + oLang.sNext + '</a></li>' +
        '<li class="page-item next disabled"><a href="#" class="page-link" title="">' + oLang.sLast + '</a></li>' +
        '</ul>'
      );
      var els = $('a', nPaging);
      $(els[0]).bind('click.DT', {
        action: "first"
      }, fnClickHandler);
      $(els[1]).bind('click.DT', {
        action: "previous"
      }, fnClickHandler);
      $(els[2]).bind('click.DT', {
        action: "next"
      }, fnClickHandler);
      $(els[3]).bind('click.DT', {
        action: "last"
      }, fnClickHandler);
    },

    "fnUpdate": function (oSettings, fnDraw) {
      var iListLength = 5;
      var oPaging = oSettings.oInstance.fnPagingInfo();
      var an = oSettings.aanFeatures.p;
      var i, j, sClass, iStart, iEnd, iHalf = Math.floor(iListLength / 2);

      if (oPaging.iTotalPages < iListLength) {
        iStart = 1;
        iEnd = oPaging.iTotalPages;
      } else if (oPaging.iPage <= iHalf) {
        iStart = 1;
        iEnd = iListLength;
      } else if (oPaging.iPage >= oPaging.iTotalPages - iHalf) {
        iStart = oPaging.iTotalPages - iListLength + 1;
        iEnd = oPaging.iTotalPages;
      } else {
        iStart = oPaging.iPage - iHalf + 1;
        iEnd = iStart + iListLength - 1;
      }
      var iLen = 0;
      for (i = 0, iLen = an.length; i < iLen; i++) {
        if (oPaging.iTotalPages <= 0) {
          $('.pagination', an[i]).css('visibility', 'hidden');
        } else {
          $('.pagination', an[i]).css('visibility', 'visible');
        }

        // Remove the middle elements
        $('li:gt(1)', an[i]).filter(':not(.next)').remove();

        // Add the new list items and their event handlers
        for (j = iStart; j <= iEnd; j++) {
          sClass = j === oPaging.iPage + 1 ? 'class="active"' : '';
          $('<li ' + sClass + '><a href="#" class="page-link">' + j + '</a></li>')
            .insertBefore($('li.next:first', an[i])[0])
            .addClass("page-item")
            .bind('click', function (e) {
              e.preventDefault();
              oSettings._iDisplayStart = (parseInt($('a', this).text(), 10) - 1) * oPaging.iLength;
              fnDraw(oSettings);
            });
        }

        // Add / remove disabled classes from the static elements
        if (oPaging.iPage === 0) {
          $('li.prev', an[i]).addClass('disabled');
        } else {
          $('li.prev', an[i]).removeClass('disabled');
        }

        if (oPaging.iPage === oPaging.iTotalPages - 1 || oPaging.iTotalPages === 0) {
          $('li.next', an[i]).addClass('disabled');
        } else {
          $('li.next', an[i]).removeClass('disabled');
        }
      }
    }
  }
});
